import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row, Typography } from 'antd';
import { JPYs, secondsToHms } from '../common/Common';
import { useEffect, useState } from 'react';
import { WorkType } from '../common/enums';
import { BlankTypes } from '../common/Constant';

const IQ3KouteiBetsuKesanshiki_Yosetsu = (props) => {
  const [isDantoriOpen, setIsDantoriOpen] = useState(true);
  const [isKakouOpen, setIsKakouOpen] = useState(true);
  const [openInputSubDetailKeys, setOpenInputSubDetailKeys] = useState(new Set());
  const [mSetHRate, setmSetHRate] = useState(0);

  const isDantoriDetailOpen = openInputSubDetailKeys.has('kakou-detail-dantori');

  const [yosetsuProcessInput, setYosetsuProcessInput] = useState([]);

  const [sagyoLenByGroup, setSagyoLanByGroup] = useState([]);

  const [karitsukeCntByGroup, setKaritsukeCntByGroup] = useState([]);

  const getDiffCoef = (deviceMst, thickness, materialTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 溶接難易度
    let weldDifficultyCoeffThMaster = deviceMst?.details?.weldDifficultyCoeffThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item.isOutOfRange
    )?.[0];

    let weldDifficultyCoeffThItems = Object.entries(deviceMst.details?.weldDifficultyCoeffThItems)?.filter(
      ([key, data]) => parseInt(key) === materialTypeId
    )?.[0];

    // 溶接難易度
    let childPartsCoeff = 0;
    weldDifficultyCoeffThItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter(
          (item) => parseInt(item.no) == weldDifficultyCoeffThMaster?.no && !item.isOutOfRange
        )?.[0]?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const getSizeCoeff = (deviceMst, weight, area) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 段取時間設定

    // 重量
    let prodSizeWeightThMaster = deviceMst?.details?.prodSizeWeightThMaster?.filter(
      (item) => (item.value == weight || item.value > weight) && !item.isOutOfRange
    );
    // 面積
    let prodSizeAreaThMaster = deviceMst?.details?.prodSizeAreaThMaster?.filter(
      (item) => (item.value == area || item.value > area) && !item.isOutOfRange
    );
    let childPartsCoeffs =
      prodSizeWeightThMaster?.length > 0 && prodSizeAreaThMaster?.length > 0
        ? deviceMst?.details?.prodSizeItems?.filter((item) => item.weightId == prodSizeWeightThMaster[0]?.no)
        : deviceMst?.details?.prodSizeItems[0];

    // サイズ係数
    let partsCoeff =
      childPartsCoeffs?.length > 0
        ? childPartsCoeffs?.[0]?.areaCoeffList?.filter(
            (item) => item.no == prodSizeAreaThMaster?.[0]?.no && !item.isOutOfRange
          )?.[0]?.value
        : childPartsCoeffs?.[0]?.areaCoeffList?.[0]?.value;

    partsCoeff = partsCoeff ? partsCoeff : 0;
    return partsCoeff;
  };

  const getProductionQuantityCoeff = (deviceMst) => {
    let productionQuantityCoeff = 1;
    let quantity = Number(props?.estimateData?.estimateProducts?.quantity);
    let partCnt = Number(props?.yosetsuData?.partCount); // 員数
    let manufacturingCnt = quantity * partCnt; // 製造数 * 員数
    // 生産個数係数
    let productionCoeffTh = deviceMst?.details?.productionQtyCoeffThMaster?.filter(
      (item) => (item.value == manufacturingCnt || item.value > manufacturingCnt) && !item.isOutOfRange
    );
    if (productionCoeffTh) {
      let productionCoeffThNo =
        productionCoeffTh?.length > 0
          ? productionCoeffTh[0]?.no
          : deviceMst?.details?.productionQtyCoeffThMaster?.[0]?.no;
      let productionCoeff =
        productionCoeffThNo == 0
          ? 0
          : deviceMst?.details?.productionQtyCoeffThItems?.filter(
              (item) => item.no == productionCoeffThNo && !item.isOutOfRange
            )[0]?.value;

      productionQuantityCoeff = productionCoeff ? productionCoeff : 1;
    }
    return productionQuantityCoeff;
  };

  const productionQuantityCoeff = getProductionQuantityCoeff(props?.deviceMst);
  // 重量
  const weight = props?.yosetsuData?.weight;
  // 面積
  const area = Number(props?.yosetsuData?.totalSurfaceArea);

  // 板厚
  const thickness = props?.parameters?.materialIq3?.filter((item) => item.id == props?.yosetsuData?.thickness)?.[0]
    ?.info?.thick;

  //材質
  const materialTypeIq3Id = props?.yosetsuData?.materialTypeIq3Id;
  //材質区分
  const materialTypeId = props?.parameters?.materialTypeIq3?.filter((item) => item.id == materialTypeIq3Id)?.[0]
    ?.materialTypeId;

  // 選択された部品の板厚により難易度係数を取得
  const diffCoef = getDiffCoef(props?.deviceMst, thickness, materialTypeId) || 0;
  // サイズ係数
  const sizeCoef = getSizeCoeff(props?.deviceMst, weight, area) || 0;

  useEffect(() => {
    let yosetsuProcessInput = props?.yosetsuData?.processInput?.filter(
      (item) => item.processId == props?.processMst?.id
    )[0];
    if (yosetsuProcessInput) {
      setYosetsuProcessInput(yosetsuProcessInput);
    }

    const weldingList = yosetsuProcessInput?.details?.[0]?.weldingList ?? [];
    const groupedSenchou = weldingList.reduce((acc, item) => {
      const type = item.yousetsuType;
      const senchou = Number(item.senchou) || 0;
      // まだそのタイプがない場合は初期化
      if (!acc[type]) {
        acc[type] = 0;
      }
      // 線長を加算
      acc[type] += senchou;
      return acc;
    }, {});
    let sagyoLenByGroup = Object.entries(groupedSenchou).map(([yousetsuType, totalSenchou]) => ({
      yousetsuType,
      totalSenchou,
    }));

    setSagyoLanByGroup(sagyoLenByGroup);

    // グループにより仮付箇所を取得
    const groupedKaritsukeCnt = weldingList.reduce((acc, item) => {
      const type = item.yousetsuType;
      const karitsukeCnt = Number(item.karitsukeCnt) || 0;
      // まだそのタイプがない場合は初期化
      if (!acc[type]) {
        acc[type] = 0;
      }
      // 仮付箇所を加算
      acc[type] += karitsukeCnt;
      return acc;
    }, {});
    let karitsukeCntByGroup = Object.entries(groupedKaritsukeCnt).map(([yousetsuType, totalKaritsukeCnt]) => ({
      yousetsuType,
      totalKaritsukeCnt,
    }));

    setKaritsukeCntByGroup(karitsukeCntByGroup);
  }, [props?.yosetsuData]);

  const dantoriOpen = () => {
    if (isDantoriOpen) {
      setIsDantoriOpen(false);
    } else {
      setIsDantoriOpen(true);
    }
  };

  const kakouOpen = () => {
    if (isKakouOpen) {
      setIsKakouOpen(false);
    } else {
      setIsKakouOpen(true);
    }
  };

  const toggleInputSubDetail = (parentKey, index) => {
    const key = `${parentKey}-${index}`;
    setOpenInputSubDetailKeys((prevKeys) => {
      const newKeys = new Set(prevKeys);
      if (newKeys.has(key)) {
        newKeys.delete(key);
      } else {
        newKeys.add(key);
      }
      return newKeys;
    });
  };

  const calDandoriTime = (deviceMst, weight, area, weldTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;

    //　基本段取時間＊サイズ係数
    let deviceDandori = Object.entries(deviceMst.details?.prepSecs)?.filter(
      ([key, data]) => parseInt(key) === weldTypeId
    )?.[0];
    let deviceDandoriTm = 0;
    deviceDandori?.map((item, index) => {
      if (index > 0) {
        deviceDandoriTm = item;
      }
    });

    let dandoriTimeSec = deviceDandoriTm;
    dandoriTimeSec = dandoriTimeSec ? dandoriTimeSec : 0;
    return dandoriTimeSec;
  };

  const calDandoriAmt = (dandoriTimeSec, deviceMst, weldType) => {
    //段階時間
    let mSetTimeMin = Number.isFinite(dandoriTimeSec / 60) ? dandoriTimeSec / 60 : 0;

    //装置の段階時間チャージ
    let deviceCharges = Object.entries(deviceMst.details?.charges)?.filter(
      ([key, data]) => parseInt(key) === weldType
    )?.[0];
    let mSetHRate = 0;
    deviceCharges?.map((item, index) => {
      if (index > 0) {
        mSetHRate = item?.prep;
      }
    });

    //段階時間＊時間チャージ
    let dandoriAmt = (mSetTimeMin * mSetHRate) / 60.0;
    dandoriAmt = dandoriAmt ? dandoriAmt : 0;
    return dandoriAmt;
  };

  const getSagyoSpeed = (deviceMst, sencho, weldTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;
    // 加工速度
    // 溶接線長
    let workSpeedThMaster = deviceMst?.details?.workSpeedThMaster?.filter(
      (item) => (item.value == sencho || item.value > sencho) && !item.isOutOfRange
    )?.[0];

    let workSpeedThItems = Object.entries(deviceMst.details?.workSpeedThItems)?.filter(
      ([key, data]) => parseInt(key) === weldTypeId
    )?.[0];

    // 加工速度
    let childPartsCoeff = 0;
    workSpeedThItems?.map((item, index) => {
      if (index > 0) {
        childPartsCoeff = item?.filter((item) => parseInt(item.no) == workSpeedThMaster?.no && !item.isOutOfRange)?.[0]
          ?.value;
      }
    });
    childPartsCoeff = childPartsCoeff ? childPartsCoeff : 0;
    return childPartsCoeff;
  };

  const getTempAttachTime = (deviceMst, thickness, weldTypeId) => {
    if (deviceMst == undefined || deviceMst?.length == 0) return 0;

    let tempInstThMaster = deviceMst?.details?.tempInstThMaster?.filter(
      (item) => (item.value == thickness || item.value > thickness) && !item.isOutOfRange
    )?.[0];

    let tempInstThItems = Object.entries(deviceMst.details?.tempInstThItems)?.filter(
      ([key, data]) => parseInt(key) === weldTypeId
    )?.[0];

    // 仮付け時間
    let tempAttachTime = 0;
    tempInstThItems?.map((item, index) => {
      if (index > 0) {
        tempAttachTime = item?.filter((item) => parseInt(item.no) == tempInstThMaster?.no && !item.isOutOfRange)?.[0]
          ?.value;
      }
    });
    tempAttachTime = tempAttachTime ? tempAttachTime : 0;
    return tempAttachTime;
  };

  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}
        onClick={() => dantoriOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isDantoriOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'段取金額/時間'}</label>
        </Col>
      </Row>
      <div style={{ display: isDantoriOpen ? 'block' : 'none', marginLeft: 10 }}>
        {yosetsuProcessInput?.details?.[0]?.weldingList?.length > 0 ? (
          yosetsuProcessInput.details[0].weldingList.map((process, index) => {
            // 1. Data Prep
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.yousetsuType)?.name || '不明';
            const detailKey = `dantori-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            /** 段取金額/時間 */
            // 基本段取時間＊サイズ係数
            const dandoriTimeSec = calDandoriTime(props?.deviceMst, weight, area, process.yousetsuType) || 0;

            //装置の段階時間チャージ
            let deviceCharges = Object.entries(props?.deviceMst.details?.charges)?.filter(
              ([key, data]) => parseInt(key) === process.yousetsuType
            )?.[0];
            let mSetHRate = 0;
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSetHRate = item?.prep;
              }
            });

            const dandoriAmt = (dandoriTimeSec * mSetHRate) / 3600;

            return (
              <div key={`dantori-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('dantori-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'基本段取時間 x サイズ係数'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} (${secondsToHms(dandoriTimeSec)})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} × ${mSetHRate} = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>
      <div style={{ display: isDantoriOpen ? 'block' : 'none', marginLeft: 10 }}>
        {yosetsuProcessInput?.details?.[0]?.subWeldingList?.length > 0 ? (
          yosetsuProcessInput.details[0].subWeldingList.map((process, index) => {
            // 1. Data Prep
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.subWeldingType)?.name ||
              '不明';
            const detailKey = `dantori-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            /** 段取金額/時間 */
            // 基本段取時間＊サイズ係数
            const dandoriTimeSec = calDandoriTime(props?.deviceMst, weight, area, process.subWeldingType) || 0;

            //装置の段階時間チャージ
            let deviceCharges = Object.entries(props?.deviceMst.details?.charges)?.filter(
              ([key, data]) => parseInt(key) === process.subWeldingType
            )?.[0];
            let mSetHRate = 0;
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSetHRate = item?.prep;
              }
            });

            const dandoriAmt = (dandoriTimeSec * mSetHRate) / 3600;

            return (
              <div key={`dantori-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('dantori-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'基本段取時間 x サイズ係数'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} (${secondsToHms(dandoriTimeSec)})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${dandoriTimeSec} × ${mSetHRate} = ${JPYs.format(Math.round(dandoriAmt))}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>

      {/* SECTION 2: 加工金額/時間 (Work) */}
      <Row
        style={{ paddingLeft: 10, width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer', marginTop: 2 }}
        onClick={() => kakouOpen()}
      >
        <Col span={4} style={{ paddingLeft: 20 }}>
          {isKakouOpen ? (
            <CaretUpOutlined style={{ fontSize: 18, marginTop: 5 }} />
          ) : (
            <CaretDownOutlined style={{ fontSize: 18, marginTop: 5 }} />
          )}
          <label style={{ marginLeft: 5 }}>{'加工金額/時間'}</label>
        </Col>
      </Row>

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        {yosetsuProcessInput?.details?.[0]?.weldingList?.length > 0 ? (
          yosetsuProcessInput.details[0].weldingList.map((process, index) => {
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.yousetsuType)?.name || '不明';
            const detailKey = `kakou-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            // 加工長
            let sagyoLen = Number(process?.senchou);
            // 同じ種類の場合、同じ種類の合計加工長を取得
            const existingGroup = sagyoLenByGroup.find((a) => Number(a.yousetsuType) === process.yousetsuType);
            if (existingGroup) {
              sagyoLen = Number(existingGroup.totalSenchou);
            }

            // 仮付箇所
            let karitsukeCnt = Number(process?.karitsukeCnt);
            // 同じ種類の場合、同じ種類の合計仮付箇所を取得
            const existingKaritsukeCntGroup = karitsukeCntByGroup.find(
              (a) => Number(a.yousetsuType) === process?.yousetsuType
            );
            if (existingKaritsukeCntGroup) {
              karitsukeCnt = Number(existingKaritsukeCntGroup.totalKaritsukeCnt);
            }

            // 作業時間（溶接時間＋仮付時間）
            // 溶接線長により該当種類の加工速度を取得
            let sagyoSpeed = getSagyoSpeed(props?.deviceMst, sagyoLen, process.yousetsuType);

            // 溶接時間（加工長*回数/加工速度＊難易度係数＊サイズ係数）
            let totalSagyoLen = sagyoLen * Number(process?.senchouKaisu);
            let sagyoTime = Number.isFinite(totalSagyoLen / sagyoSpeed)
              ? (totalSagyoLen / sagyoSpeed) * diffCoef * sizeCoef * 60
              : 0;

            // 仮付時間
            let tempAttachTimeSecParm = getTempAttachTime(props?.deviceMst, thickness, process.yousetsuType);
            // 仮付時間   仮付時間＊仮付箇所＊仮付回数＊難易度係数＊サイズ係数
            let tempAttachTimeSec =
              tempAttachTimeSecParm * diffCoef * sizeCoef * process?.karitsukeKaisu * karitsukeCnt;
            // 作業時間（溶接時間＋仮付時間）

            const sagyoTimeSec = (sagyoTime + tempAttachTimeSec) * productionQuantityCoeff || 0;

            // 作業金額
            let mSagyoTimeMin = sagyoTimeSec / 60;
            //装置の作業時間チャージ
            let mSagyoHRate = 0;
            //装置の段階時間チャージ
            let deviceCharges = Object.entries(props?.deviceMst.details?.charges)?.filter(
              ([key, data]) => parseInt(key) === process?.yousetsuType
            )?.[0];
            let mSetHRate = 0;
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSetHRate = item?.prep;
              }
            });
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSagyoHRate = item?.work;
              }
            });
            const sagyoAmt = (mSagyoTimeMin * mSagyoHRate) / 60.0;

            return (
              <div key={`kakou-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('kakou-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>
                              {
                                '（加工長x回数/加工速度x難易度係数xサイズ係数x60）+ (仮付時間x仮付箇所x仮付回数x難易度係数xサイズ係数)'
                              }
                            </label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`(${sagyoLen} x ${Number(
                              process?.senchouKaisu
                            )} / ${sagyoSpeed} x ${diffCoef} x ${sizeCoef} x 60) + (${tempAttachTimeSecParm} x ${
                              process?.karitsukeKaisu
                            } x ${karitsukeCnt} x ${diffCoef} x ${sizeCoef}) = ${sagyoTimeSec} (${secondsToHms(
                              sagyoTimeSec
                            )})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${sagyoTimeSec} × ${mSagyoHRate} / 3600 = ${JPYs.format(
                              Math.round(sagyoAmt)
                            )}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>

      <div style={{ display: isKakouOpen ? 'block' : 'none', marginLeft: 10 }}>
        {yosetsuProcessInput?.details?.[0]?.subWeldingList?.length > 0 ? (
          yosetsuProcessInput.details[0].subWeldingList.map((process, index) => {
            const typeName =
              props?.processMst?.details?.processDetailTypes?.find((t) => t.id == process.subWeldingType)?.name ||
              '不明';
            const detailKey = `kakou-detail-${index}`;
            const isOpen = openInputSubDetailKeys.has(detailKey);

            // 加工長
            let sagyoLen = Number(process?.senchou);
            // 同じ種類の場合、同じ種類の合計加工長を取得
            const existingGroup = sagyoLenByGroup.find((a) => Number(a.yousetsuType) === process.subWeldingType);
            if (existingGroup) {
              sagyoLen = Number(existingGroup.totalSenchou);
            }

            // 仮付箇所
            let karitsukeCnt = Number(process?.karitsukeCnt);
            // 同じ種類の場合、同じ種類の合計仮付箇所を取得
            const existingKaritsukeCntGroup = karitsukeCntByGroup.find(
              (a) => Number(a.yousetsuType) === process?.subWeldingType
            );
            if (existingKaritsukeCntGroup) {
              karitsukeCnt = Number(existingKaritsukeCntGroup.totalKaritsukeCnt);
            }

            // 作業時間（溶接時間＋仮付時間）
            // 溶接線長により該当種類の加工速度を取得
            let sagyoSpeed = getSagyoSpeed(props?.deviceMst, sagyoLen, process.subWeldingType);

            // 溶接時間（加工長*回数/加工速度＊難易度係数＊サイズ係数）
            let totalSagyoLen = sagyoLen * Number(process?.senchouKaisu);
            let sagyoTime = Number.isFinite(totalSagyoLen / sagyoSpeed)
              ? (totalSagyoLen / sagyoSpeed) * diffCoef * sizeCoef * 60
              : 0;

            // 仮付時間
            let tempAttachTimeSecParm = getTempAttachTime(props?.deviceMst, thickness, process.subWeldingType);
            // 仮付時間   仮付時間＊仮付箇所＊仮付回数＊難易度係数＊サイズ係数
            let tempAttachTimeSec =
              tempAttachTimeSecParm * diffCoef * sizeCoef * process?.karitsukeKaisu * karitsukeCnt;
            // 作業時間（溶接時間＋仮付時間）

            const sagyoTimeSec = (sagyoTime + tempAttachTimeSec) * productionQuantityCoeff || 0;

            // 作業金額
            let mSagyoTimeMin = sagyoTimeSec / 60;
            //装置の作業時間チャージ
            let mSagyoHRate = 0;
            //装置の段階時間チャージ
            let deviceCharges = Object.entries(props?.deviceMst.details?.charges)?.filter(
              ([key, data]) => parseInt(key) === process?.subWeldingType
            )?.[0];
            let mSetHRate = 0;
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSetHRate = item?.prep;
              }
            });
            deviceCharges?.map((item, index) => {
              if (index > 0) {
                mSagyoHRate = item?.work;
              }
            });
            const sagyoAmt = (mSagyoTimeMin * mSagyoHRate) / 60.0;

            return (
              <div key={`kakou-${index}`} style={{ width: '100%', borderBottom: '1px solid #ddd' }}>
                <Row
                  style={{ width: '100%', cursor: 'pointer', padding: '4px 0' }}
                  onClick={() => toggleInputSubDetail('kakou-detail', index)}
                >
                  <Col span={10} style={{ paddingLeft: 30 }}>
                    {isOpen ? (
                      <CaretUpOutlined style={{ fontSize: 18 }} />
                    ) : (
                      <CaretDownOutlined style={{ fontSize: 18 }} />
                    )}
                    <label style={{ marginLeft: 5 }}>{typeName}</label>
                  </Col>
                </Row>

                {isOpen && (
                  <div>
                    <div>
                      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                        <Col span={4} style={{ paddingLeft: 50, paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工時間'}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{'加工金額'}</label>
                          </div>
                        </Col>
                        <Col span={12} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <Typography.Text
                              ellipsis={{
                                tooltip:
                                  '（加工長x回数/加工速度x難易度係数xサイズ係数x60）+ (仮付時間x仮付箇所x仮付回数x難易度係数xサイズ係数)',
                              }}
                            >
                              {
                                '（加工長x回数/加工速度x難易度係数xサイズ係数x60）+ (仮付時間x仮付箇所x仮付回数x難易度係数xサイズ係数)'
                              }
                            </Typography.Text>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{}</label>
                            <Typography.Text
                              ellipsis={{
                                tooltip: '加工時間(秒) x 加工時間チャージ/3600(秒)',
                              }}
                            >
                              {'加工時間(秒) x 加工時間チャージ/3600(秒)'}
                            </Typography.Text>
                          </div>
                        </Col>
                        <Col span={8} style={{ paddingTop: 10 }}>
                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`(${sagyoLen || 0} x ${Number(
                              process?.senchouKaisu || 0
                            )} / ${sagyoSpeed} x ${diffCoef} x ${sizeCoef} x 60) + (${tempAttachTimeSecParm || 0} x ${
                              process?.karitsukeKaisu || 0
                            } x ${karitsukeCnt || 0} x ${diffCoef} x ${sizeCoef}) = ${sagyoTimeSec} (${secondsToHms(
                              sagyoTimeSec
                            )})`}</label>
                          </div>

                          <div
                            style={{
                              borderBottom: '2px solid #eeebeb',
                              paddingBottom: 4,
                            }}
                          >
                            <label>{`${sagyoTimeSec} × ${mSagyoHRate} / 3600 = ${JPYs.format(
                              Math.round(sagyoAmt)
                            )}`}</label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div style={{ padding: '10px 40px', fontSize: 11, color: '#999' }}>詳細データはありません。</div>
        )}
      </div>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_Yosetsu;
